/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GoToFrontDesk01/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function GoToFrontDesk01({
  children,
  viewPath = "/DesignSystem/Svgs/GoToFrontDesk01",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 1062,
  height = 794.4,
  fill = "#E0F0E7",
  fill2 = "#404040",
  fill3 = "#F0F0F0",
  fill4 = "#8D575F",
  fill5 = "#2B2B2B",
  fill7 = "#9E616A",
  fill8 = "#009AEC",
  fill9 = "#007CD2",
  fill11 = "#292929",
  fill16 = "#DFDCE3",
  fill17 = "#BFBDC1",
  fill18 = "#65617D",
  fill19 = "#D7D4DD",
  fill22 = "#4F4D5E",
  fill27 = "#64BCEC",
  fill28 = "#EEE",
  fill29 = "#C7C7C7",
  fill31 = "#CFCFCF",
  fill32 = "#DCDCDC",
  fill33 = "#BBB",
  fill34 = "#009659",
  fill36 = "#FFD037",
  fill42 = "#525252",
  fill43 = "#9D9CB5"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="GoToFrontDesk01.Svg"
  data-view-path={viewPath}
 viewBox="0 0 1062 794.4"
 style={{'--as-1-1C9PRQ': alignSelf,'--mt-2-1C9PRQ': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1C9PRQ': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1C9PRQ': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1C9PRQ': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1C9PRQ': opacity,'--w-7-1C9PRQ': typeof width === 'number' ? `${width}px` : width,'--h-8-1C9PRQ': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<ellipse
  data-testid="GoToFrontDesk01.SvgEllipse"
  data-view-path={viewPath}
 cx={531}
 cy={685.8}
 rx={470}
 ry={95.2}
 style={{'--f-9-1C9PRQ': fill}}
 className={`views-block ${styles.SvgEllipse}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath"
  data-view-path={viewPath}
 d="M580.4 606.9s2 13-1.1 21.1-15.6 34.5 1.1 34.5 29.9 4.2 29.9-1.4c0 0 3.7-4.9 2.4-13.4-2-13.8-2.4-37.1-2.4-37.1l-29.9-3.7z"
 style={{'--f-9-1C9PRQ': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:1"
  data-view-path={viewPath}
 d="M713.7 132.4h1.7v16.2h-1.7zM604.2 171.8h1.7V188h-1.7zM591.1 444.2h1.7v16.2h-1.7z"
 style={{'--f-9-1C9PRQ': fill3}}
 className={`views-block ${styles.SvgPath1}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:2"
  data-view-path={viewPath}
 d="M704.8 86.9s-12.8 36.4-4.9 42c7.9 5.6-26.6 51.4-26.6 51.4l-41.4-11.2 22.7-38.3s3-38.3 3-43.9 47.2 0 47.2 0z"
 style={{'--f-9-1C9PRQ': fill4}}
 className={`views-block ${styles.SvgPath2}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:3"
  data-view-path={viewPath}
 d="M726.3 346.6s3.7 46.7 0 71-9.3 91.6-9.3 91.6 0 127.1-20.6 128.9c-20.6 1.9-35.5 3.7-37.4-3.7-1.9-7.5 9.3-11.2 3.7-14.9s-7.5-16.8 0-31.8 0-166.3 0-166.3l-35.5 95.3s-5.7 54.8-9.4 66 3.7 37.7-9.3 39.5c-13.1 1.9-25.7-2.3-33.1-6-7.5-3.7 5.7-8 2-9.9s-11.8-10.3-8-12.1 9.4-73.8 9.4-73.8 10.3-191.5 23.4-199 21.5 5.4 21.5 5.4l102.6 19.8z"
 style={{'--f-9-1C9PRQ': fill5}}
 className={`views-block ${styles.SvgPath3}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:4"
  data-view-path={viewPath}
 d="M692.6 630.6v14.9s16.8 40.6 0 40.6-29.9 4.2-29.9-1.4v-50.4l29.9-3.7z"
 style={{'--f-9-1C9PRQ': fill5}}
 className={`views-block ${styles.SvgPath4}`}
/>
<circle
  data-testid="GoToFrontDesk01.SvgCircle"
  data-view-path={viewPath}
 cx={672.7}
 cy={80.3}
 r={33.6}
 style={{'--f-9-1C9PRQ': fill7}}
 className={`views-block ${styles.SvgCircle}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:5"
  data-view-path={viewPath}
 d="M688.9 142.9s-9.3 28-24.3 22.4l-14.9-5.6-26.2 179.4s20.5 29.9 50.4 11.2 15-207.4 15-207.4z"
 style={{'--f-9-1C9PRQ': fill8}}
 className={`views-block ${styles.SvgPath5}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:6"
  data-view-path={viewPath}
 d="M662.7 137.3l-8.4-17.7s-49.5 23.4-57 30.8c-7.5 7.5-7.5 18.7-7.5 18.7l13.1 46.7s-3.7 102.8-3.7 106.5c0 3.7-13.1 24.3-3.7 16.8 9.3-7.5 11.2-14.9 18.7-3.7s24.3 24.3 24.3 24.3l24.2-222.4z"
 style={{'--f-9-1C9PRQ': fill9}}
 className={`views-block ${styles.SvgPath6}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:7"
  data-view-path={viewPath}
 d="M589.5 262.1L563.7 308s10 43.9 2.9 41.1c-7.2-2.8-5.9-11.1-5.9-11.1s-10.8 18.8-30.7 16c-13.8-2 13.2-9.7 10.8-23.4-2.9-16.1 24.2-79.1 24.2-79.1l24.5 10.6z"
 style={{'--f-9-1C9PRQ': fill7}}
 className={`views-block ${styles.SvgPath7}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:8"
  data-view-path={viewPath}
 d="M700.5 38.2c-1 1.1-2.5 1.9-4 2.1l6.1.5c0 1.3-.4 2.6-1.3 3.6 7.4 0 13.3 6.9 14.6 14.2s-.9 14.6-3.3 21.5c-1 3-4 6.6-6.5 4.7 0-2.5-.1-5.2-1.3-7.4s-3.9-3.9-6.3-3.1c1.1-5.4-3.3-10.7-8.5-12.5s-10.9-1-16.3-.1c-5.9 1-12 2-16.8 5.5-9.6 6.9-10.8 20.5-11.2 32.3-1-5.2-6-8.6-11.2-7.6-.3.1-.7.2-1 .3l3.1-10.2c.4-1.1-1-3-1.4-1.9 1.2-2.5 1.8-5.2 1.8-7.9l-2.8 1.1c-2.4-10.2 3.2-20.7 9.7-28.9 2.2-3 4.9-5.7 8-7.8 6.7-4.3 15.2-4.1 23.2-3.9 3.8.2 22.9 8.1 25.4 5.5z"
 style={{'--f-9-1C9PRQ': fill11}}
 className={`views-block ${styles.SvgPath8}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:9"
  data-view-path={viewPath}
 d="M679.5 131.7s15.2-14.9 20.7-14 12.9 14 12.9 14 44.8 14.9 43 29.9c-1.8 14.9-22.4 87.8-22.4 87.8s-16.8 87.8-1.9 97.2-71 33.6-72.9 22.4-5.6-123.3 0-140.1 20.6-97.2 20.6-97.2zM616 160.3l-22.8-3.8s-27.7 67.3-30.7 74.4c-3.1 7.1-12.6 41.5-10.8 41.8s39.9-.9 39 4.7L616 160.3z"
 style={{'--f-9-1C9PRQ': fill9}}
 className={`views-block ${styles.SvgPath9}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:10"
  data-view-path={viewPath}
 d="M614.9 337.4h88.5c8.6-39.7 9.3-78.1 0-114.7h-88.5c14.3 36 15.2 74.1 0 114.7z"
 style={{'--f-9-1C9PRQ': fill3}}
 className={`views-block ${styles.SvgPath10}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:11"
  data-view-path={viewPath}
 d="M739.3 288.7l-26.2 11.2s-50.4 7.5-50.4-13.1 50.4-9.3 50.4-9.3l16.8-5.4 9.4 16.6z"
 style={{'--f-9-1C9PRQ': fill7}}
 className={`views-block ${styles.SvgPath11}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:12"
  data-view-path={viewPath}
 d="M733.7 150.4l22.4 5.6 16.8 99s5.6 26.2-3.7 28c-9.3 1.9-35.5 16.8-35.5 16.8s-3.8-28-11.2-28l18.7-14.9-11.2-65.4 3.7-41.1z"
 style={{'--f-9-1C9PRQ': fill9}}
 className={`views-block ${styles.SvgPath12}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:13"
  data-view-path={viewPath}
 d="M698.4 745.4s-55.6-3-69.2-10.9c-13.6-8-32.7-8-32.8-8l-197.6-33.4-92-21.8-16.4-2.2 54.2-62.1 1.7-.7s-21.2 15.4 37.7 10.1c46.7-4.2 38.4 40.4 78 52.7 33.5 10.4 34.5 10.2 77.9 12.1 34.2 1.6 58.5-30.7 112.4-5.9 28.8 13.3 46.1 70.1 46.1 70.1z"
 style={{'--f-9-1C9PRQ': fill16}}
 className={`views-block ${styles.SvgPath13}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:14"
  data-view-path={viewPath}
 d="M413.2 681c-.6 2.7-.5 5.2 1 7.2 3 3 23.5 5.6 27 7.8l-140.8-27 2-18.5 79.9-34.6s21.5-2.7 34.5 10.8c15.1 15.7 8.1 34.1 3.7 40-2.8 4-6.2 9.5-7.3 14.3z"
 style={{'--f-9-1C9PRQ': fill17}}
 className={`views-block ${styles.SvgPath14}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:15"
  data-view-path={viewPath}
 d="M293.4 408.6l90.6 4.9v202.9l-83.7 47.9-31.3-28.9 6.5-95.5-6.5-89.1z"
 style={{'--f-9-1C9PRQ': fill18}}
 className={`views-block ${styles.SvgPath15}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:16"
  data-view-path={viewPath}
 d="M215.3 381.6l123.1-33.1c2.9-.9 253.3 2.5 360.1 12.7s154.1 91 169.3 130.8 13.1 85.2 9.1 115.8c-2.6 18.9-8.3 37.3-16.8 54.4 0 0 25.4-237.8-227.8-249.8l-417-30.8z"
 style={{'--f-9-1C9PRQ': fill19}}
 className={`views-block ${styles.SvgPath16}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:17"
  data-view-path={viewPath}
 d="M842.7 634.4l-18.9 64.2-42.8 41.8-53.7 10.9-83.6-14.9v-297s14.4-9.5 15.9-9.5 41.8 6.5 41.8 6.5l91.3 65.4 3.8 2.7 40.8 60.7 5.4 69.2z"
 style={{'--f-9-1C9PRQ': fill18}}
 className={`views-block ${styles.SvgPath17}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:18"
  data-view-path={viewPath}
 d="M643.7 427v309.4l8.1 1.5V427z"
 style={{'--f-9-1C9PRQ': fill18}}
 className={`views-block ${styles.SvgPath18}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:19"
  data-view-path={viewPath}
 d="M293.4 408.6l90.6 4.9v202.9l-83.7 47.9-31.3-28.9 6.5-95.5-6.5-89.1zM643.7 427v309.4l8.1 1.5V427z"
 style={{'--f-9-1C9PRQ': fill22}}
 className={`views-block ${styles.SvgPath19}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:20"
  data-view-path={viewPath}
 d="M794.4 522.5c-59.8-49.1-126.1-56.3-150.8-57.2v-26s14.4-9.5 15.9-9.5 41.8 6.5 41.8 6.5l91.3 65.4 1.8 20.8z"
 style={{'--f-9-1C9PRQ': fill22}}
 className={`views-block ${styles.SvgPath20}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:21"
  data-view-path={viewPath}
 d="M154.6 511s6.2 16.3 12.8 35.2c5.8 16.8 12.1 35.8 14.6 47.4 1.3 4.9 3.7 9.5 7 13.4 16.1 20.4 53.2 40.2 59.6 47.3 7.8 8.6 51.7 14.8 51.7 14.8v-264l-29.3-9.5h-37.3l-48.3 21.9-24.9 36.8-5.9 56.7z"
 style={{'--f-9-1C9PRQ': fill18}}
 className={`views-block ${styles.SvgPath21}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:22"
  data-view-path={viewPath}
 d="M230.7 408.5s-61.2 49.3-51.6 122.9c5.9 45.3 18.9 102 121.2 132.9v7l-43.4-12.1-29.5-16.3-22.4-20.2-27.5-33.5-12.8-27.4-4.7-36-2.7-41.2 6.6-35.2 15.5-23 18.9-14.6 32.4-3.3z"
 style={{'--f-9-1C9PRQ': fill19}}
 className={`views-block ${styles.SvgPath22}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:23"
  data-view-path={viewPath}
 d="M864.9 585.8c6.7 35.8 1.5 73.1-16.1 105-51.3 93.2-160.4 65.8-192.6 55.2-7.7-2.5-15.4-4.7-23.3-6.5L302 674c-122.1-21.2-147.3-120-147.3-120-24.1-76.2-7.6-120.7 14.3-145.8 17.6-20 43.3-30.7 69.9-29.2l42.1 2.2 350.2 25.9c174.7 1.8 221.4 113.1 233.7 178.7zm-34.6 4.5c-11.8-56.4-58-138.2-206.8-143.2-6.8-.2-13.6-.8-20.4-1.7l-310.6-29.8-38.7-2c-29.1-1.5-57.2 12.1-73.3 36.3-15.4 23.2-23.7 59.8-4.7 116.5 0 0 23.3 86.3 136.2 104.8l303.8 55.2c7.4 1.6 14.8 3.5 22.1 5.7 29.7 9.2 128.5 32.4 176.5-45.7 17.6-28.6 22.8-63.2 15.9-96.1z"
 style={{'--f-9-1C9PRQ': fill16}}
 className={`views-block ${styles.SvgPath23}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:24"
  data-view-path={viewPath}
 d="M622.375 179.547l.505-5.878 21.62 1.857-.505 5.879z"
 style={{'--f-9-1C9PRQ': fill27}}
 className={`views-block ${styles.SvgPath24}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:25"
  data-view-path={viewPath}
 d="M468.9 353.8l123.2 6.1 22.6-5.9-122.9-6.2z"
 style={{'--f-9-1C9PRQ': fill28}}
 className={`views-block ${styles.SvgPath25}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:26"
  data-view-path={viewPath}
 d="M614.7 354v2l-22.6 9.8-123.2-5.9V354l123.2 5.9z"
 style={{'--f-9-1C9PRQ': fill29}}
 className={`views-block ${styles.SvgPath26}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:27"
  data-view-path={viewPath}
 d="M589.5 262.1L563.7 308s10 43.9 2.9 41.1c-7.2-2.8-5.9-11.1-5.9-11.1s-10.8 18.8-30.7 16c-13.8-2 13.2-9.7 10.8-23.4-2.9-16.1 24.2-79.1 24.2-79.1l24.5 10.6z"
 style={{'--f-9-1C9PRQ': fill7}}
 className={`views-block ${styles.SvgPath27}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:28"
  data-view-path={viewPath}
 d="M431.4 334.3l199.1 10.6-27.6-152.5-199.1 8s1.3 41.8 7.9 72.8c6.6 31 19.7 61.1 19.7 61.1z"
 style={{'--f-9-1C9PRQ': fill31}}
 className={`views-block ${styles.SvgPath28}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:29"
  data-view-path={viewPath}
 d="M490.8 373.5l40.2 2.2v-86.3h-40.2z"
 style={{'--f-9-1C9PRQ': fill32}}
 className={`views-block ${styles.SvgPath29}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:30"
  data-view-path={viewPath}
 d="M630.5 344.1s-15.5-35.5-21.7-71c-7.9-45.3-5.9-80.8-5.9-80.8"
 style={{'--f-9-1C9PRQ': fill33}}
 className={`views-block ${styles.SvgPath30}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:31"
  data-view-path={viewPath}
 d="M376.4 277.8s5.6 7.3-2.6 18.3c-8.1 11-14.9 20.3-12.2 27.1 0 0 12.3-20.4 22.3-20.7 10.1-.2 3.5-12.4-7.5-24.7z"
 style={{'--f-9-1C9PRQ': fill34}}
 className={`views-block ${styles.SvgPath31}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:32"
  data-view-path={viewPath}
 d="M376.4 277.8c.5.7.9 1.5 1.1 2.3 9.8 11.5 15 22.2 5.6 22.4-8.7.2-19.2 15.9-21.7 19.8l.3.9s12.3-20.4 22.3-20.7 3.4-12.4-7.6-24.7z"
 style={{'--f-9-1C9PRQ': fill34}}
 className={`views-block ${styles.SvgPath32}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:33"
  data-view-path={viewPath}
 d="M386.7 287.1c0 2.6-.3 4.6-.6 4.6-.4 0-.6-2.1-.6-4.6 0-2.6.4-1.4.7-1.4.3.1.5-1.1.5 1.4z"
 style={{'--f-9-1C9PRQ': fill36}}
 className={`views-block ${styles.SvgPath33}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:34"
  data-view-path={viewPath}
 d="M390.3 290.2c-2.3 1.2-4.2 2-4.4 1.7-.2-.3 1.5-1.6 3.8-2.8 2.3-1.2 1.4-.3 1.5 0 .1.3 1.3-.2-.9 1.1z"
 style={{'--f-9-1C9PRQ': fill36}}
 className={`views-block ${styles.SvgPath34}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:35"
  data-view-path={viewPath}
 d="M346.9 277.8s-5.6 7.3 2.6 18.3 14.9 20.3 12.1 27.1c0 0-12.3-20.4-22.3-20.7-9.9-.2-3.4-12.4 7.6-24.7z"
 style={{'--f-9-1C9PRQ': fill34}}
 className={`views-block ${styles.SvgPath35}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:36"
  data-view-path={viewPath}
 d="M346.9 277.8c-.5.7-.9 1.5-1.1 2.3-9.8 11.5-15 22.2-5.6 22.4 8.7.2 19.2 15.9 21.7 19.8l-.3.9s-12.3-20.4-22.3-20.7-3.4-12.4 7.6-24.7z"
 style={{'--f-9-1C9PRQ': fill34}}
 className={`views-block ${styles.SvgPath36}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:37"
  data-view-path={viewPath}
 d="M336.6 287.1c0 2.6.3 4.6.6 4.6s.6-2.1.6-4.6c0-2.6-.4-1.4-.7-1.4-.3.1-.5-1.1-.5 1.4z"
 style={{'--f-9-1C9PRQ': fill36}}
 className={`views-block ${styles.SvgPath37}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:38"
  data-view-path={viewPath}
 d="M333 290.2c2.3 1.2 4.2 2 4.4 1.7s-1.5-1.6-3.8-2.8c-2.3-1.2-1.4-.3-1.5 0-.1.3-1.3-.2.9 1.1z"
 style={{'--f-9-1C9PRQ': fill36}}
 className={`views-block ${styles.SvgPath38}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:39"
  data-view-path={viewPath}
 d="M391.7 313.5l-.3 2.3-.4 3.2-.2 1.3-.4 3.2-.2 1.3-.4 3.2-4.5 36.5c-.4 3.3-5.7 5.8-12.2 5.8h-23.2c-6.4 0-11.7-2.6-12.1-5.8l-4.4-36.6-.4-3.2-.2-1.3-.4-3.2-.2-1.3-.4-3.2-.3-2.3c-.2-1.8 2.7-3.4 6.3-3.4l47.4.1c3.8 0 6.7 1.6 6.5 3.4z"
 style={{'--f-9-1C9PRQ': fill42}}
 className={`views-block ${styles.SvgPath39}`}
/>
<path
  data-testid="GoToFrontDesk01.SvgPath:40"
  data-view-path={viewPath}
 d="M391.4 315.7l-.4 3.2h-58.7l-.4-3.2zM390.8 320.3l-.4 3.2h-57.5l-.4-3.2zM390.3 324.8l-.4 3.2h-56.4l-.4-3.2z"
 style={{'--f-9-1C9PRQ': fill43}}
 className={`views-block ${styles.SvgPath40}`}
/>
</svg>
{children}
</React.Fragment>)
}